import React from "react";
import { UiComponents } from "@simulanisindia/ui";
import { DashboardIcon, InvoiceIcon, OrgManageIcon } from "../Assets/Icons";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeUserData } from "../Store/slice/userSlice";
const { MainLayout, Header, Sidebar } = UiComponents;

const ChildComponent = ({ children }) => children;

const PrivateLayout = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const MainMenuItems = [
    {
      id: "1",
      key: "dashboard",
      tooltip: "Dashboard",
      icon: <DashboardIcon />,
      clickHandler: () => navigate(`/dashboard`),
    },
  ];

  const menuItems = [
    {
      id: "2",
      key: "organization",
      tooltip: "Organization Management",
      icon: <OrgManageIcon />,
      clickHandler: () => navigate(`/organization/management/dashboard`),
    },
    {
      id: "3",
      key: "invoice",
      tooltip: "Invoices",
      icon: <InvoiceIcon />,
      clickHandler: () => navigate("/invoice/list"),
    },
    {
      id: "4",
      key: "category",
      tooltip: "Category",
      icon: <OrgManageIcon />,
      clickHandler: () => navigate("/category/list"),
    },
  ];

  const logoutHandler = () => {
    dispatch(removeUserData());
    window.location.reload();
  };

  return (
    <MainLayout
      Header={
        <Header
          appLogo={null}
          showSearch={false}
          showDrawer={false}
          showThemeSwitch={false}
          appName="Subscription Management"
          logoutHandler={logoutHandler}
        />
      }
      SideBar={<Sidebar mainMenuItems={MainMenuItems} menuItems={menuItems} />}
      Component={<ChildComponent> {children} </ChildComponent>}
    />
  );
};

export default PrivateLayout;
